// Sheet identity readers. `page.name` is the source PDF filename — never the
// sheet. Accept both the legacy `page.label` ("<number> - <title>") and the
// newer separate `number`/`title` fields.

const SEPARATOR = " - ";

export function sheetNumber(page) {
  if (page?.number) return page.number;
  if (!page?.label) return null;
  const idx = page.label.indexOf(SEPARATOR);
  return idx === -1 ? page.label : page.label.slice(0, idx);
}

export function sheetTitle(page) {
  if (page?.title) return page.title;
  if (!page?.label) return null;
  const idx = page.label.indexOf(SEPARATOR);
  return idx === -1 ? null : page.label.slice(idx + SEPARATOR.length);
}

/** The legacy single-string form, for consumers that still want it. */
export function sheetLabel(page) {
  const number = sheetNumber(page);
  const title = sheetTitle(page);
  if (number && title) return `${number}${SEPARATOR}${title}`;
  return number || title || null;
}
